import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { IMapGeometryWicket } from "~app/common/components/map/map.settings";
import { KartgeometriSymbols } from "~app/common/components/map/symbols/kartgeometri.mappings";
import { ApiClientService } from "~app/common/services/api-client.service";
import { IKartgeometri } from "~app/features/map/popups/kartgeometri-popup/kartgeometri.model";
import { IVirkeskopAvtal } from "../models/avtal-models-legacy";
import { Geometri } from "../models/karta-models";

@Injectable({
    providedIn: "root"
})
export class KartaService {
    private readonly apiClientService = inject(ApiClientService);

    renderKartgeometrier(kartgeometrier: Geometri[]): IMapGeometryWicket[] {
        const result = [];
        kartgeometrier.forEach(k => {
            const ks = this.renderKartgeometri(k, null, k.atgardGuid);
            result.push(...ks);
        });
        return result;
    }

    renderKartgeometri(geometri: Geometri, geoid?, atgardId?): IMapGeometryWicket[] {
        const symbols = KartgeometriSymbols.getSymbolStyles(geometri.kartgeometri);
        let parent: any;
        const geometries: IMapGeometryWicket[] = [];
        symbols.forEach(s => {
            const geo = {
                wkt: geometri.kartgeometri.geometri,
                id: geometri.guid,
                geoid: geoid,
                label: this.getLabelForGeometry(geometri.kartgeometri),
                visible: true,
                tag: geometri.kartgeometri,
                styleName: s,
                symbolText: geometri.kartgeometri.karttext,
                parent: parent
            } as IMapGeometryWicket;
            if (!parent) {
                parent = geo;
            }
            geometries.push(geo);
        });
        return geometries;
    }

    getAvtalDraftByFastighetsUuid(fastighetUuid?: string): Observable<IVirkeskopAvtal> {
        return this.apiClientService.get<IVirkeskopAvtal>(`/virkeskopsavtal/new?fastighetUuid=${fastighetUuid ? fastighetUuid : ""}`);
    }

    private getLabelForGeometry(kartgeometri: IKartgeometri): string {
        if (kartgeometri.subtyp3) {
            return `${kartgeometri.subtyp2}/${kartgeometri.subtyp3}`;
        } else if (kartgeometri.subtyp2) {
            return kartgeometri.subtyp2;
        }
        return kartgeometri.subtyp1;
    }
}
